import { render, staticRenderFns } from "./AtualizacaoBeneficiario.vue?vue&type=template&id=8039573a"
import script from "./AtualizacaoBeneficiario.vue?vue&type=script&lang=js"
export * from "./AtualizacaoBeneficiario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports